package com.loyola.acessoescola.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Error(
    val detail: String? = null,
    val error: String? = null
){
    val errorMessage: String
        get() = detail ?: error ?: ""
}


@Serializable
data class AcessoEscolaInRecord(
    @SerialName(RECORD_ID_NAME)
    val recordID: String,
    @SerialName(NAME_NAME)
    val name: String,
    @SerialName(CPF_NAME)
    val cpf: String,
    @SerialName(PHONE_NAME)
    val phone: String,
    @SerialName(BOUND_NAME)
    val bound: String,
    @SerialName(EMAIL_NAME)
    val email: String
)

@Serializable
data class AcessoEscolaOutRecord(
    @SerialName(NAME_NAME)
    val name: String,
    @SerialName(CPF_NAME)
    val cpf: String,
    @SerialName(PHONE_NAME)
    val phone: String,
    @SerialName(BOUND_NAME)
    val bound: String,
    @SerialName(EMAIL_NAME)
    val email: String,
    @SerialName(PHOTO_NAME)
    val photo: String
)


@Serializable
data class JsonInValues(
    @SerialName("json_values")
    var jsonValues: AcessoEscolaInRecord
)

@Serializable
data class JsonOutValues(
    @SerialName("id")
    val recordID: String,
    @SerialName("values")
    val jsonValues: AcessoEscolaOutRecord
)

fun JsonOutValues.toJsonInValues(): JsonInValues{
    return JsonInValues(
        jsonValues = AcessoEscolaInRecord(
            recordID = recordID,
            name = jsonValues.name,
            cpf = jsonValues.cpf,
            phone = jsonValues.phone,
            bound = jsonValues.bound,
            email = jsonValues.email
        )
    )
}

@Serializable
data class RecordsResponse(
    @SerialName("records")
    val records: List<JsonOutValues>
)

@Serializable
data class RecordResponse(
    val record: JsonOutValues
)